export enum EType {
  TERM = 'TERM',
  PRIVACY = 'PRIVACY',
}
